import { COVERGO_SAAS_DEV } from "../consts.js"

export const p_tenant_53_dev = {
	"p-tenant-53-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "p_tenant_53_dev",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	}
}
